module.exports = __webpack_public_path__ + "img/کارت-ویزیت-لمینت-براق.e54ec5a3.png";